import { useState } from "react";
import { Menu, X } from "lucide-react";
import { MAILTO } from "@/lib/site";

const LINKS = [
  { label: "Company", href: "#buyers" },
  { label: "Sea Buckthorn", href: "#berry" },
  { label: "Product Matrix", href: "#specs" },
  { label: "Quality & Docs", href: "#quality" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="site-header" data-testid="site-header">
      <div className="wrap inner" style={{ position: "relative" }}>
        <a href="#home" className="brand-row" data-testid="brand-link">
          <div className="brand-mark" aria-label="Himalayan Actives logo">
            <svg viewBox="0 0 120 72" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true">
              <path d="M58 68 C58 48 58 31 58 8" stroke="#063b2a" strokeWidth="5" strokeLinecap="round" fill="none" />
              <path d="M58 39 C38 24 24 19 8 23 C20 42 36 51 58 39Z" fill="#063b2a" />
              <path d="M62 39 C82 24 96 19 112 23 C100 42 84 51 62 39Z" fill="#063b2a" />
              <path d="M58 66 C37 58 22 50 5 50 C16 66 34 72 58 66Z" fill="#063b2a" />
              <path d="M62 66 C83 58 98 50 115 50 C104 66 86 72 62 66Z" fill="#063b2a" />
              <path d="M60 5 C50 17 50 26 60 36 C70 26 70 17 60 5Z" fill="#063b2a" />
            </svg>
          </div>
          <div className="brand-name">Himalayan Actives</div>
        </a>
        <nav className="site-nav" aria-label="Primary">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}>
              {l.label}
            </a>
          ))}
        </nav>
        <button
          className="mobile-menu-btn"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle navigation"
          data-testid="mobile-menu-btn"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
        {open && (
          <nav className="site-nav mobile-menu-open" data-testid="mobile-menu" aria-label="Mobile">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
            <a href={MAILTO} className="connect-pill" style={{ alignSelf: "flex-start" }} data-testid="mobile-nav-connect">
              Connect →
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}
